import { FC } from "react";

interface IProps {
  quote: string;
  author: string;
  affiliation: string;
}

// Derives up to 2 initials from an author's name for the colored badge
// (testimonials intentionally have no photo assets).
const getInitials = (name: string): string =>
  name
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

export const TestimonialCard: FC<IProps> = ({ quote, author, affiliation }) => (
  <div className="landing-testimonials-page__card">
    <p className="landing-testimonials-page__quote">&ldquo;{quote}&rdquo;</p>
    <div className="landing-testimonials-page__author-row">
      <span className="landing-testimonials-page__badge" aria-hidden="true">
        {getInitials(author)}
      </span>
      <div>
        <p className="landing-testimonials-page__author">{author}</p>
        <p className="landing-testimonials-page__affiliation">{affiliation}</p>
      </div>
    </div>
  </div>
);
